module.exports = __webpack_public_path__ + "static/Outdoor-Street-Light-eaf0c1a99d14d5a60480f4d0a8581d48.jpg";